export const rawApiProfessions = [
  {
    "IsDefault": "N",
    "EId": "260",
    "Coefficient": 1412260,
    "Id": 98661,
    "Code": "1412260",
    "Name": "без професії"
  },
  {
    "IsDefault": "N",
    "EId": "286",
    "Coefficient": 1412286,
    "Id": 116804,
    "Code": "1412286",
    "Name": "викладачі та студенти інститутів, технікумів"
  },
  {
    "IsDefault": "N",
    "EId": "377",
    "Coefficient": 1412377,
    "Id": 116848,
    "Code": "1412377",
    "Name": "водії будь-якого виду наземного транспорту"
  },
  {
    "IsDefault": "N",
    "EId": "290",
    "Coefficient": 1412290,
    "Id": 116808,
    "Code": "1412290",
    "Name": "гардеробники"
  },
  {
    "IsDefault": "N",
    "EId": "385",
    "Coefficient": 1412385,
    "Id": 116856,
    "Code": "1412385",
    "Name": "двірники"
  },
  {
    "IsDefault": "N",
    "EId": "287",
    "Coefficient": 1412287,
    "Id": 116805,
    "Code": "1412287",
    "Name": "домогосподарки"
  },
  {
    "IsDefault": "N",
    "EId": "387",
    "Coefficient": 1412387,
    "Id": 116858,
    "Code": "1412387",
    "Name": "інженерно-технічні працівники"
  },
  {
    "IsDefault": "N",
    "EId": "288",
    "Coefficient": 1412288,
    "Id": 116806,
    "Code": "1412288",
    "Name": "кіоскери"
  },
  {
    "IsDefault": "N",
    "EId": "386",
    "Coefficient": 1412386,
    "Id": 116857,
    "Code": "1412386",
    "Name": "кур’єри"
  },
  {
    "IsDefault": "N",
    "EId": "372",
    "Coefficient": 1412372,
    "Id": 116843,
    "Code": "1412372",
    "Name": "медичні працівники (крім працівників швидкої допомоги)"
  },
  {
    "IsDefault": "N",
    "EId": "284",
    "Coefficient": 1412284,
    "Id": 116863,
    "Code": "1412284",
    "Name": "офісні працівники"
  },
  {
    "IsDefault": "N",
    "EId": "374",
    "Coefficient": 1412374,
    "Id": 116845,
    "Code": "1412374",
    "Name": "охорона офісів і складських приміщень"
  },
  {
    "IsDefault": "N",
    "EId": "293",
    "Coefficient": 1412293,
    "Id": 116811,
    "Code": "1412293",
    "Name": "персонал готелів"
  },
  {
    "IsDefault": "N",
    "EId": "370",
    "Coefficient": 1412370,
    "Id": 116841,
    "Code": "1412370",
    "Name": "працівники бактеріологічних і санепідемстанції"
  },
  {
    "IsDefault": "N",
    "EId": "292",
    "Coefficient": 1412292,
    "Id": 116810,
    "Code": "1412292",
    "Name": "працівники банків (крім осіб, які зайняті інкасуванням та перевезенням грошей)"
  },
  {
    "IsDefault": "N",
    "EId": "373",
    "Coefficient": 1412373,
    "Id": 116844,
    "Code": "1412373",
    "Name": "працівники ветлікарень"
  },
  {
    "IsDefault": "N",
    "EId": "380",
    "Coefficient": 1412380,
    "Id": 116851,
    "Code": "1412380",
    "Name": "працівники, зайняті у річковому і озерному судноплавстві"
  },
  {
    "IsDefault": "N",
    "EId": "378",
    "Coefficient": 1412378,
    "Id": 116849,
    "Code": "1412378",
    "Name": "працівники зв`язку (листоноші)"
  },
  {
    "IsDefault": "N",
    "EId": "379",
    "Coefficient": 1412379,
    "Id": 116850,
    "Code": "1412379",
    "Name": "працівники мистецтва (учасники балетних груп і танцювальних колективів), налагоджувані, комірники"
  },
  {
    "IsDefault": "N",
    "EId": "368",
    "Coefficient": 1412368,
    "Id": 116839,
    "Code": "1412368",
    "Name": "працівники неважкого промислового виробництва (паперово-целюлозна, легка, харчова, поліграфічна промисловість, електроенергетика)"
  },
  {
    "IsDefault": "N",
    "EId": "285",
    "Coefficient": 1412285,
    "Id": 116803,
    "Code": "1412285",
    "Name": "працівники освіти (педагогічний персонал позашкільних дитячих закладів)"
  },
  {
    "IsDefault": "N",
    "EId": "382",
    "Coefficient": 1412382,
    "Id": 116853,
    "Code": "1412382",
    "Name": "працівники по виготовленню виробів без механічної спеціальної і хімічної обробки"
  },
  {
    "IsDefault": "N",
    "EId": "375",
    "Coefficient": 1412375,
    "Id": 116846,
    "Code": "1412375",
    "Name": "працівники побутового та комунального господарства"
  },
  {
    "IsDefault": "N",
    "EId": "291",
    "Coefficient": 1412291,
    "Id": 116809,
    "Code": "1412291",
    "Name": "працівники пошти, телеграфу, телефону (крім листонош)"
  },
  {
    "IsDefault": "N",
    "EId": "384",
    "Coefficient": 1412384,
    "Id": 116855,
    "Code": "1412384",
    "Name": "працівники сільського господарства (крім працюючих з отрутохімікатами, а також на сільськогосподарських і будівельних механізмах)"
  },
  {
    "IsDefault": "N",
    "EId": "376",
    "Coefficient": 1412376,
    "Id": 116847,
    "Code": "1412376",
    "Name": "працівники сфери побутового обслуговування населення"
  },
  {
    "IsDefault": "N",
    "EId": "383",
    "Coefficient": 1412383,
    "Id": 116854,
    "Code": "1412383",
    "Name": "працівники торговельної мережі і харчування (крім поварів)"
  },
  {
    "IsDefault": "N",
    "EId": "289",
    "Coefficient": 1412289,
    "Id": 116807,
    "Code": "1412289",
    "Name": "робітники преси"
  },
  {
    "IsDefault": "N",
    "EId": "369",
    "Coefficient": 1412369,
    "Id": 116840,
    "Code": "1412369",
    "Name": "працівники сільського господарства (окрім механізаторів широкого профілю)"
  },
  {
    "IsDefault": "N",
    "EId": "371",
    "Coefficient": 1412371,
    "Id": 116842,
    "Code": "1412371",
    "Name": "співробітники підприємств громадського харчування"
  },
  {
    "IsDefault": "N",
    "EId": "381",
    "Coefficient": 1412381,
    "Id": 116852,
    "Code": "1412381",
    "Name": "члени команд рибальських флотилій на річках і озерах"
  },
  {
    "IsDefault": "N",
    "EId": "294",
    "Coefficient": 1412294,
    "Id": 116812,
    "Code": "1412294",
    "Name": "W1"
  },
  {
    "IsDefault": "N",
    "EId": "346",
    "Coefficient": 1412346,
    "Id": 116838,
    "Code": "1412346",
    "Name": "W2"
  }
];

// Мапінг старих строкових значень форми для зворотної сумісності
export const legacyProfessionMap = {
  'none': '1412260',
  'guard': '1412374', // охорона офісів і складських приміщень
  'other': '1412260',
};

// Технічні службові коди, які не мають відображатися користувачеві як назва професії
const technicalCodes = ['1412294', '1412346'];

/**
 * Парсить повний список професій для селекта, сортуючи за українською абеткою
 */
export function parseProfessionsList(apiData = rawApiProfessions) {
  return apiData
    .filter(item => !technicalCodes.includes(item.Code))
    .map(item => ({
      name: item.Name,
      value: item.Code,
      code: item.Code,
      id: item.Id,
      eId: item.EId,
    }))
    .sort((a, b) => {
      // "без професії" першим у списку, якщо він присутній
      if (a.value === '1412260') return -1;
      if (b.value === '1412260') return 1;
      return a.name.localeCompare(b.name, 'uk');
    });
}

export const ACCIDENT_PROFESSIONS = parseProfessionsList(rawApiProfessions);
